(function(){
  var TARGET_FORM_ID   = 'SutJke';
  var SF_ORG_ID        = '00D41000000FeLR';
  var SF_ENDPOINT      = 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D41000000FeLR';
  var SF_RECORD_TYPE   = '012UH00000AbmeD';
  var SF_FIELD_CBT     = '00NUH00000CZf9R';
  var SF_FIELD_CHANNEL = '00N5d00000JFp6f';

  var accumulatedData = {};

  function findValue(meta, keys) {
    for (var i = 0; i < keys.length; i++) {
      if (meta[keys[i]] !== undefined && meta[keys[i]] !== '') {
        return meta[keys[i]];
      }
    }
    return '';
  }

  function postToSalesforce(meta) {
    // Try every possible key variation Klaviyo might use
    var firstName = findValue(meta, [
      'First Name', 'first_name', 'firstname', 'firstName', '$first_name', 'first'
    ]);
    var lastName = findValue(meta, [
      'Last Name', 'last_name', 'lastname', 'lastName', '$last_name', 'last'
    ]) || '(Not provided)';
    var email = findValue(meta, [
      'email', 'Email', '$email'
    ]);
    var phone = findValue(meta, [
      'phone_number', 'Phone Number', 'phone', 'Phone', '$phone_number', 'phonenumber'
    ]);
    var message = findValue(meta, [
      'message', 'Message', 'description', 'Description', 'comments', 'Comments'
    ]);
    var timezone = findValue(meta, [
      'time zone', 'Time Zone', 'timezone', 'TimeZone', 'time_zone', 'timezoneus', 'Time Zone US'
    ]);
    var calltime = findValue(meta, [
      'preferred call back time', 'Preferred Call Back Time', 'preferred_call_back_time',
      'preferredcallbacktime', 'callbacktime', 'call_back_time'
    ]);
    var zip = findValue(meta, [
      'zip', 'Zip Code', 'zip_code', 'Zip', '$zip', 'postal_code', 'postalcode'
    ]) || '';
    var preferredCallBack = [timezone, calltime].filter(Boolean).join(' \u2014 ');

    var fields = {
      'oid':         SF_ORG_ID,
      'retURL':      '',
      'first_name':  firstName,
      'last_name':   lastName,
      'email':       email,
      'phone':       phone,
      'description': message,
      'zip':         zip,
      'lead_source': 'Website',
      'recordType':  SF_RECORD_TYPE
    };
    fields[SF_FIELD_CBT]     = preferredCallBack;
    fields[SF_FIELD_CHANNEL] = 'Heartland Sheds';

    // Hidden iframe form POST — bypasses DataDome bot protection
    var iframeName = 'sf_' + Date.now();
    var iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    var form = document.createElement('form');
    form.method = 'POST';
    form.action = SF_ENDPOINT;
    form.target = iframeName;
    form.style.display = 'none';

    Object.keys(fields).forEach(function(key) {
      var input   = document.createElement('input');
      input.type  = 'hidden';
      input.name  = key;
      input.value = fields[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();

    setTimeout(function() {
      if (document.body.contains(form))   document.body.removeChild(form);
      if (document.body.contains(iframe)) document.body.removeChild(iframe);
    }, 5000);
  }

  window.addEventListener('klaviyoForms', function(e) {
    if (!e.detail || e.detail.formId !== TARGET_FORM_ID) return;

    // Accumulate metaData from every stepSubmit
    if (e.detail.type === 'stepSubmit' && e.detail.metaData) {
      Object.assign(accumulatedData, e.detail.metaData);
    }

    // On final submit — merge and POST to SF
    if (e.detail.type === 'submit') {
      if (e.detail.metaData) {
        Object.assign(accumulatedData, e.detail.metaData);
      }
      postToSalesforce(accumulatedData);
      accumulatedData = {};
    }
  });

})();
